import { useTranslation } from 'react-i18next';

import { BaseDialog } from '../custom-dialog';

export type ApiErrorDialogProps = {
  open: boolean;
  onClose: VoidFunction;
  errorMessage: string;
};

export default function ApiErrorModal({ open, onClose }: Readonly<ApiErrorDialogProps>) {
  const { t } = useTranslation();

  return <BaseDialog title={t('learner.3986')} open={open} onClose={onClose} />;
}
